module.exports = __webpack_public_path__ + "static/media/colorforcode-home.01df0c98.jpg";